export class ClientInfoRecallModel { 
    client_no:number
    pet_name:string
    last_name:string
    first_name:string
    address:string
    city:string
    state:string
    zip:string
    zip4:string
    brief_hist_code:string
    brief_hist_date:string
    pet_code:string
    brief_hist_category:string

    constructor(
        client_no:number,
        pet_name:string,
        last_name:string,
        first_name:string,
        address:string,
        city:string,
        state:string,
        zip:string,
        zip4:string,
        brief_hist_code:string,
        brief_hist_date:string,
        pet_code:string,
        brief_hist_category:string,
    ) { 
        this.client_no = client_no
        this.pet_name = pet_name
        this.last_name = last_name
        this.first_name = first_name
        this.address = address
        this.city = city
        this.state = state
        this.zip = zip
        this.zip4 = zip4
        this.brief_hist_code = brief_hist_code
        this.brief_hist_date = brief_hist_date
        this.pet_code = pet_code
        this.brief_hist_category = brief_hist_category 
    }
}